import '.d{display:flex;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.at{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.d9{background:var(--palette-white);}.ssr-plugin'
import '.e6{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.al{max-width:77.5rem;}.ssr-plugin'
import '.f1{justify-content:stretch;}.ssr-plugin'
import '.b2{position:sticky;}.ssr-plugin'
import '.b3{top:0px;}.ssr-plugin'
import '.b9{z-index:10;}.ssr-plugin'
import '.fa{padding-block:1rem;}.ssr-plugin'
import '.fb{height:3rem;}.ssr-plugin'
import '.bj{justify-content:space-between;}.ssr-plugin'
import '.br{flex-wrap:wrap;}.ssr-plugin'
import '.fc{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.dt{margin-top:2rem;}.ssr-plugin'
import '.fd{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d a2 at e d9"
      >
        <div className="e6 d r at e"
        >
          <div className="al d e f1 b2 b3 b9 d9"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fa fb d bj r br"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fc d e a2 dt fd al"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
